import { Fragment } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import { HttpResponse } from 'shell/models/http-response';
import { noop } from 'shell/utils/noop';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import FormCirculationArea, { CirculationAreaForm } from 'system/components/toponymy/form';
import { CirculationArea } from 'shell/models/circulation-area';
import { CommonToponymyCrumbs } from '../constants';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { transformResponseCirculationArea } from 'system/utils/transformer-circulation-area';

const CirculationAreaDetailPage = (): React.ReactElement => {
  const params = useParams();
  const [queryParams] = useSearchParams();

  const civic = queryParams.get('civico') || '';
  const exponent = queryParams.get('esponente') || '';

  const [circulationAreaData] = useHttpFetch<HttpResponse<CirculationArea>, CirculationAreaForm>(
    `${__TOPONYMY_API_URL__}/areaCircolazione/${params.id}`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
        loading: true,
        errorCatching: true,
      },
      transformer: (response) => transformResponseCirculationArea(response, civic, exponent),
    }
  );

  const navigate = useNavigate();

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonToponymyCrumbs, { name: 'Dettaglio Area Circolazione' }]} />
      {circulationAreaData.isLoading && !circulationAreaData.data ? null : (
        <FormCirculationArea
          title="Dettaglio Area Circolazione"
          onOk={noop}
          onCancel={() => {
            navigate('/sistema/toponomastica/area-di-circolazione');
          }}
          disabled
          initialValues={circulationAreaData.data as CirculationAreaForm}
          circulationArea={Number(params.id)}
        />
      )}
    </Fragment>
  );
};

CirculationAreaDetailPage.displayName = 'Cirtculation Area Detail page component';

export default CirculationAreaDetailPage;
